export const CAMPAIGN_PHONE_SESSION_KEY = 'phone';
export const DEFAULT_CAMPAIGN_PHONE_SESSION_KEY = 'defaultPhone';

export const readSessionValue = (key) => {
  if (typeof window === 'undefined') return '';

  try {
    const rawValue = sessionStorage.getItem(key);

    if (!rawValue) return '';

    const parsedValue = JSON.parse(rawValue);
    return typeof parsedValue === 'string' ? parsedValue : '';
  } catch {
    return '';
  }
};

export const writeSessionValue = (key, value) => {
  if (typeof window === 'undefined' || !value) return;
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const readStoredCampaignPhone = () => readSessionValue(CAMPAIGN_PHONE_SESSION_KEY);

export const readStoredDefaultCampaignPhone = () =>
  readSessionValue(DEFAULT_CAMPAIGN_PHONE_SESSION_KEY);
